import { removeWhitespaces } from './removeWhitespaces';

export const stringToNumberOrNull = (value: string): number | null => {
  const spacesRemoved = removeWhitespaces(value);
  if (spacesRemoved === '') {
    return null;
  }
  return Number(removeWhitespaces(value));
};
